"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ApplicationLayoutBodyBanner = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["textColor", "backgroundColor", "isSticky", "className", "children"];

var ApplicationLayoutBodyBanner = function ApplicationLayoutBodyBanner(props) {
  var textColor = props.textColor,
      backgroundColor = props.backgroundColor,
      isSticky = props.isSticky,
      className = props.className,
      children = props.children,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var bannerClasses = (0, _classnames.default)('ApplicationLayoutBodyBanner', textColor, backgroundColor, isSticky && 'position-sticky top-0 z-index-3', className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, remainingProps, {
    className: bannerClasses
  }), children);
};

exports.ApplicationLayoutBodyBanner = ApplicationLayoutBodyBanner;
ApplicationLayoutBodyBanner.defaultProps = {
  textColor: 'text-color-white',
  backgroundColor: 'bg-primary',
  isSticky: true
};
ApplicationLayoutBodyBanner.propTypes = {
  textColor: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  isSticky: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = ApplicationLayoutBodyBanner;
exports.default = _default;